/**
 * @generated SignedSource<<f7521316db7465ead93e09333448a97d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      }
    ],
    "concreteType": "AccountLedgerSummary",
    "kind": "LinkedField",
    "name": "getaccountledgersummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payInAr",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAndFullArBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "payInArAvailable",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetAndArBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetArAuthBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balanceForTopupCalc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "liabilityBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "equityBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPayoutBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "authBalance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "floatBalanceDisplay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "floatBalanceForAuth",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountLedgerSummaryFetchQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountLedgerSummaryFetchQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3c156bf7f071107a88a1a835390c498c",
    "id": null,
    "metadata": {},
    "name": "AccountLedgerSummaryFetchQuery",
    "operationKind": "query",
    "text": "query AccountLedgerSummaryFetchQuery(\n  $accountId: UUID!\n) {\n  getaccountledgersummary(accountId: $accountId) {\n    assetBalance\n    payInAr\n    assetAndFullArBalance\n    payInArAvailable\n    assetAndArBalance\n    assetArAuthBalance\n    balanceForTopupCalc\n    liabilityBalance\n    equityBalance\n    maxPayoutBalance\n    authBalance\n    floatBalanceDisplay\n    floatBalanceForAuth\n  }\n}\n"
  }
};
})();

node.hash = "45e92f2f0b05237aae227aa2867a8167";

module.exports = node;
